import useWepapp from "./useWepapp";
import { Button, Card, Col, Flex, Image, Row } from "antd";
import icon from "../../../assets/images/export.svg"
import { useMediaQuery } from "react-responsive";
import { setIsLoading, setProfile } from "../slices/webappSlice";
import { getProfile } from "../services/webAppApi";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { generateRandomString } from "utils/helper";
import dayjs from "dayjs";
import i18n from "i18n";


const useUser = () => {
    const Head = "User page"
    const isPortrait = useMediaQuery({ orientation: 'portrait' })
    const dispatch = useDispatch()
    const { isLoading, profile } = useSelector((state) => state.webapp);

    const serviceProfile = async (params) => {
        try {
            dispatch(setIsLoading(true));
            const response = await getProfile({
                ...params,
                requestId: generateRandomString(),
                page: 0, size: 100
            });
            console.log("data", response?.data?.content);
            dispatch(setProfile(response?.data?.content))
        } catch (error) {
            console.log("error", error);
        } finally {
            dispatch(setIsLoading(false));
        }
    }


    useEffect(() => {
        serviceProfile()
    }, [])

    function profile1() {
        return (
            <Card style={{
                boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                borderRadius: "1rem",
                backgroundColor: "rgba(255, 255, 255, 0.5)",
            }}>

                {isPortrait ?
                    <>
                        <Flex vertical>
                            <Row style={{ justifyContent: "Center", }}>
                                <Image preview={false} width={"15vh"} src={`data:image/png;base64, ${profile.employeeImage}`} />
                            </Row>
                            <Row style={{ justifyContent: "Center", height: "5vh", justifyContent: "center", alignContent: "center" }}>
                                <span>{profile.name + " " + profile.surName}</span>
                            </Row>
                        </Flex>

                        <Flex vertical style={{ color: "#909090", fontSize: "1.4vh" }}>
                            <Row>
                                <Col span={12}><span>รหัสพนักงาน</span></Col>
                                <Col span={12} style={{ textAlign: "right" }}><span>{profile?.employeeNo}</span></Col>
                            </Row>
                            <Row>
                                <Col span={12}><span>หมายเลขบัตรประชาชน</span></Col>
                                <Col span={12} style={{ textAlign: "right" }}><span>{(profile?.identificationNo)?.replace(/.(?=.{4})/g, "x")}</span></Col>
                            </Row>
                            <Row>
                                <Col span={12}><span>เบอร์โทรศัพท์</span></Col>
                                <Col span={12} style={{ textAlign: "right" }}><span>{profile?.mobileNumber?.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3")}</span></Col>
                            </Row>
                            <Row>
                                <Col span={12}><span>วัน/ เดือน/ ปีเกิด</span></Col>
                                <Col span={12} style={{ textAlign: "right" }}><span>{dayjs(profile.dateOfBirth)?.format("DD MMM BBBB") || null}</span></Col>
                            </Row>
                        </Flex>
                    </>
                    :
                    <Row>
                        <Col span={10}>
                            <Flex vertical>
                                <Row style={{ justifyContent: "Center", }}>
                                    <Image preview={false} width={"13vw"} src={`data:image/png;base64, ${profile.employeeImage}`} />
                                </Row>
                                <Row style={{ justifyContent: "Center", height: "10vh", justifyContent: "center", alignContent: "center" }}>
                                    <span>{profile.name + " " + profile.surName}</span>
                                </Row>
                            </Flex>
                        </Col>
                        <Col span={14}>
                            <Flex vertical style={{ color: "#909090", fontSize: "2vw" }}>
                                <Row>
                                    <Col span={12}><span>รหัสพนักงาน</span></Col>
                                    <Col span={12} style={{ textAlign: "right" }}><span>{profile?.employeeNo}</span></Col>
                                </Row>
                                <Row>
                                    <Col span={12}><span>หมายเลขบัตรประชาชน</span></Col>
                                    <Col span={12} style={{ textAlign: "right" }}><span>{(profile?.identificationNo)?.replace(/.(?=.{4})/g, "x")}</span></Col>
                                </Row>
                                <Row>
                                    <Col span={12}><span>เบอร์โทรศัพท์</span></Col>
                                    <Col span={12} style={{ textAlign: "right" }}><span>{profile?.mobileNumber?.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3")}</span></Col>
                                </Row>
                                <Row>
                                    <Col span={12}><span>วัน/ เดือน/ ปีเกิด</span></Col>
                                    <Col span={12} style={{ textAlign: "right" }}><span>{dayjs(profile.dateOfBirth)?.format("DD MMM BBBB") || null}</span></Col>
                                </Row>
                            </Flex>
                        </Col>
                    </Row>
                }
            </Card>
        )
    }
    function exit() {
        return (
            <Card style={{
                boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                borderRadius: "1rem",
                backgroundColor: "rgba(255, 255, 255, 0.5)",
                padding: 0,
                height: isPortrait ? "5vh" : "10vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }}>
                <Flex style={{ display: "flex", alignItems: "center" }}>
                    <Image preview={false} width={isPortrait ? "2vh" : "2vw"} src={icon} />
                    <span style={{ color: "#909090", fontSize: isPortrait ? "2vh" : "1.8vw", paddingLeft: "1vh" }}>ออกจากระบบ</span>
                </Flex>
            </Card>
        );
    }

    return {
        Head,
        profile1,
        exit,
    }
}
export default useUser;